var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.897 1.30326C11.5263 0.605464 10.804 0.171875 10.0135 0.171875C9.22303 0.171875 8.50073 0.605465 8.13 1.30432L0.312607 16.073C0.139137 16.3973 0.053208 16.7612 0.0632962 17.1289C0.0733844 17.4966 0.179141 17.8552 0.370134 18.1696C0.558377 18.4853 0.825712 18.7465 1.14575 18.9273C1.46578 19.1082 1.82745 19.2024 2.19504 19.2008H17.832C18.5862 19.2008 19.2691 18.8151 19.6579 18.1696C19.8486 17.8551 19.9542 17.4965 19.9643 17.1289C19.9744 16.7613 19.8886 16.3974 19.7155 16.073L11.897 1.30326Z",
    fill: "#FD3757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93857 7.48438H11.0692V12.811H8.93857V7.48438ZM8.9375 13.8764H11.0682V16.007H8.9375V13.8764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedIcon);
export default __webpack_public_path__ + "static/media/WarningRedIcon.831b450d53375bdb5e371a13ae47fa75.svg";
export { ForwardRef as ReactComponent };